import { CSSProperties } from 'react';
import { SerializedStyles, css } from '@emotion/react';
import { DataTableEmpty } from '@frontend/assets';
import { useTranslation } from '@frontend/i18n';
import { Text } from '@frontend/design-system';

type CallEmptyStateProps = {
  className?: SerializedStyles;
  mainText?: string;
  style?: CSSProperties;
  subText?: string;
  svg?: string;
};

export const CallEmptyState = ({ className, mainText, style, subText, svg }: CallEmptyStateProps) => {
  const { t } = useTranslation('analytics');

  return (
    <div className={`no-data ${className ?? ''}`.trim()} css={styles.wrapper} style={style}>
      <img alt='' src={svg ?? DataTableEmpty} />
      <Text color='subdued' textAlign='center'>
        {mainText ?? t('No data available')}
      </Text>
      {subText && (
        <Text className='sub-text' color='subdued' textAlign='center'>
          {subText}
        </Text>
      )}
    </div>
  );
};

const styles = {
  wrapper: css`
    align-items: center;
    display: flex;
    flex-direction: column;
    width: 100%;

    img {
      width: 180px;
    }
  `,
};
